import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const BREAKPOINT_LAPTOP = 1024;

class SocialBanner {
	constructor(dom) {
		this.dom = dom;
	}

	init() {
		if (window.innerWidth >= BREAKPOINT_LAPTOP) {
			this._initDesktop();
		} else {
			this._initMobile();
		}
	}

	_initDesktop() {
		const leftStrip = this.dom.querySelector('[data-strip-col="left"]');
		const rightStrip = this.dom.querySelector('[data-strip-col="right"]');

		if (leftStrip) this._shuffleStrip(leftStrip);
		if (rightStrip) this._shuffleStrip(rightStrip);
		const trigger = {
			trigger: this.dom,
			start: "top bottom",
			end: "bottom top",
			scrub: 0.3,
		};

		if (leftStrip) {
			gsap.fromTo(
				leftStrip,
				{ y: 200 },
				{ y: -200, ease: "none", scrollTrigger: trigger }
			);
		}

		if (rightStrip) {
			gsap.fromTo(
				rightStrip,
				{ y: -200 },
				{ y: 200, ease: "none", scrollTrigger: trigger }
			);
		}
	}

	_shuffleStrip(strip) {
		const photos = [...strip.children];
		for (let i = photos.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			strip.appendChild(photos[j]);
			photos.splice(j, 1);
		}
	}

	_initMobile() {
		const strip = this.dom.querySelector("[data-strip-mobile]");
		if (!strip) return;

		this._shuffleStrip(strip);

		const container = strip.parentElement;
		const overflow = Math.max(0, strip.scrollWidth - container.offsetWidth);
		const travel = Math.min(overflow, 160);

		gsap.fromTo(
			strip,
			{ x: 0 },
			{
				x: -travel,
				ease: "none",
				scrollTrigger: {
					trigger: this.dom,
					start: "top bottom",
					end: "bottom top",
					scrub: 0.3,
				},
			}
		);
	}
}

export default SocialBanner;
